import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { LoginForm } from "../../../components/features/auth/forms/login-form.tsx";
import { AuthLayout } from "../../../components/layout/auth-layout/auth-layout.tsx";
import { SQE_AUTH_LAYOUT_PROPS } from "./sqe-auth-layout.tsx";

interface LoginLocationState {
  message?: string;
}

const WELCOME_BANNER_DISMISS_MS = 5000;
const SQE_LOGIN_DOMAINS = ["sqelabs.com"] as const;

/** The SQE Labs sign-in experience. Authentication remains in LoginForm. */
export function SqeLoginPage() {
  const location = useLocation();
  const state = (location.state ?? null) as LoginLocationState | null;
  const [welcomeMessage, setWelcomeMessage] = useState<string | null>(
    state?.message ?? null,
  );
  const cleared = useRef(false);

  useEffect(() => {
    if (state?.message && !cleared.current) {
      cleared.current = true;
      window.history.replaceState({}, "", location.pathname);
    }
  }, [state, location.pathname]);

  useEffect(() => {
    if (!welcomeMessage) return;
    const id = window.setTimeout(
      () => setWelcomeMessage(null),
      WELCOME_BANNER_DISMISS_MS,
    );
    return () => window.clearTimeout(id);
  }, [welcomeMessage]);

  return (
    <AuthLayout
      {...SQE_AUTH_LAYOUT_PROPS}
      title="Sign in to your account"
      subtitle="Enter your credentials to access the SQE Labs portal."
      welcomeMessage={welcomeMessage}
    >
      <LoginForm
        allowedEmailDomains={SQE_LOGIN_DOMAINS}
        emailPlaceholder="you@sqelabs.com"
      />
    </AuthLayout>
  );
}
